import axios from "axios";
import moment from 'moment';

import { config } from "../../config";
import { LocalStorage } from "../../data/localstorage";

export class Notifications {

	async getunreadNotificationsCount(userId: any) {
		let response = await axios.get(config.api.host + "/notifications/getUnreadNotificationsCount/" + userId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });

        return response.data.data.count;
	}
	async getAllNotifications(userId: any) {
		let response = await axios.get(config.api.host + "/notifications/getAllNotifications/" + userId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });

        return response;
	}

	async getNotificationById(userId: any, notificationId: any) {
		let response = await axios.get(config.api.host + "/notifications/getNotificationById/" + userId + "/"+notificationId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });

        return response.data.data;
	}
}